export default __webpack_public_path__ + "static/media/tick.112e1f05.svg";